import { getMarket } from '../locale';
import request from '../request';
const getStoreSuggestions = ({ query, locale, country }) => {
    const defaultCountry = getMarket('lowerCase');
    return request
        .post('storesearchsuggestwithgl/locale', {
        type: 'storelocator',
        apiVersion: 2,
        customLocale: locale,
        data: {
            countryCode: country || defaultCountry,
            searchString: query,
        },
    })
        .then(({ data }) => data.suggestions);
};
export default getStoreSuggestions;
//# sourceMappingURL=getStoreSuggestions.js.map